(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["nemo-collection-slick-slider"] && !window.DesignMode) return;
  try {
    
  jQuery(document).ready(function () {
    jQuery('[data-nemo-slick-slider]').each(function(){
      var productGrid = jQuery(this);
    
    if (!jQuery(productGrid).hasClass('iniciado')) {
      jQuery(productGrid).addClass('iniciado');
      var nav = productGrid.data("nav");
      var custombutton = productGrid.data("custombutton");
      if (typeof custombutton != "undefined") {
        nav = false;
      }
      jQuery(productGrid).slick({
        nextArrow: '<div class="arrow-next make-arrow-do-looks" style="font-size: {{ arrows_font_size }}"><i class="zmdi zmdi-chevron-right" aria-hidden="true"></i></div>',
        prevArrow: '<div class="arrow-prev make-arrow-do-looks" style="font-size: {{ arrows_font_size }}"><i class="zmdi zmdi-chevron-left" aria-hidden="true"></i></i></div>',
        rtl: false,
        slidesToShow: (productGrid.data("loop"), productGrid.data("items")),
        slidesToScroll: (productGrid.data("loop"), productGrid.data("items")),
        rows: productGrid.data("row"),
        arrows: nav,
        dots: productGrid.data("dots"),
        infinite: productGrid.data("loop"),
        adaptiveHeight: !0,
        responsive: [
          {
            breakpoint: 1920,
            settings: {
              slidesToShow: (
                productGrid.data("loop"),
                productGrid.data("items")
              ),
              slidesToScroll: (productGrid.data("loop"),
                productGrid.data("items"))
            }
          },
          {
            breakpoint: 1439,
            settings: {
              slidesToShow: productGrid.data("items_lg_desktop"),
              slidesToScroll: productGrid.data("items_lg_desktop")
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: productGrid.data("items_lg_tablet"),
              slidesToScroll: productGrid.data("items_lg_tablet")
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: productGrid.data("items_tablet"),
              slidesToScroll: productGrid.data("items_tablet")
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: productGrid.data("items_mobile"),
              slidesToScroll: productGrid.data("items_mobile")
            }
          },
          {
            breakpoint: 480,
            settings: {
              rows: 2,
              slidesToShow: productGrid.data("items_mobiles"),
              slidesToScroll: productGrid.data("items_mobiles"), arrows: !1
            }
          },
        ],
      })
    }
                         });
  })

  } catch(e) { console.error(e); }
})();

})();
